<template>
</template>

<script>
export default {
    name: 'Logout',

    mounted() {
        localStorage.removeItem('access_token');

        setTimeout(() => {
            window.location.replace('/login');
        }, 800);
    },

}
</script>